/* eslint-disable */
import { SET_ALL_VENUE_LIST,SET_ALL_EXAM_CENTERS_LIST,SET_ALL_STATES_LIST,SET_ALL_DISTRICTS_LIST,SET_ALL_SUBDISTRICTS_LIST,SET_ALL_VILLAGES_LIST,
        SET_ALL_COORDINATOR_ROLES_LIST,SET_ALL_EXAM_MODES_LIST,SET_ALL_COORDINATOR_GENDERS_LIST,SET_ALL_UNAPPROVAL_ENTITY_LIST,SET_ALL_APPROVED_ENTITY_LIST,
        SET_UPLOAD_CSV,GET_VENUE_ERRORLIST,SET_UNAPPROVAL_PAGE_NO_COUNTER,SET_APPROVED_PAGE_NO_COUNTER,SET_ALL_EXAM_CENTERS_LIST_BY_ADVT_ID, 
        SET_ALL_VENUES_LIST_BY_EXAM_CENTER_ID, SET_VENUE_DETAILS_BY_VENUE_ID, SET_ALL_ACTIVE_VENUE_ADVT, SET_ALL_ACTIVE_VENUE_ADVT_PAGE_NO_COUNTER, SET_EXAM_DISPLAY_NAME_BY_EXAM_ID,
        SET_EXAM_SUBJECTS_LIST, SET_FORM_2_DATA_STATUS} from "../../common/constants/ActionTypes";
const initialState = {
    errorMessage: "",
    showLoader: false,
    ällVenueList:[],
    allExamCentersList:[],
    allStatesList:[],
    allDistrictsList:[],
    allSubDistrictsList:[],
    allVillagesList:[],
    allExamModesList:[],
    allCoordinatorRoles:[],
    allCoordinatorGenders:[],
    allUnapprovalEntityList:[],
    unapprovalPageNoCounter: 0,
    allApprovedEntityList:[],
    approvalPageNoCounter: 0,
    uploadCsv:[],
    venueErrorList:[],
    allExamCentersListByAdvtId:[],
    allVenuesListByExamCenterId:[],
    allVenueDetailsList:[],
    allActiveVenueAdvtList:[],
    allActiveVenueAdvtPageNoCounter: 0,
    getExamDisplayNameList:[],
    getExamSubjectsDropDownList:[],
    getForm2DataAlreadyExistsStatus: {}
}

export default function venueManagementReducer(state = initialState , action) {
    switch(action.type){
        case SET_ALL_VENUE_LIST:
            return {
                ...state,
                ällVenueList: action.payload
            }
        case SET_ALL_EXAM_CENTERS_LIST:
            return {
                ...state,
                allExamCentersList: action.payload
            }
        case SET_ALL_STATES_LIST:
            return {
                ...state,
                allStatesList: action.payload
            }
        case SET_ALL_DISTRICTS_LIST:
            return {
                ...state,
                allDistrictsList: action.payload
            }
        case SET_ALL_SUBDISTRICTS_LIST:
                return {
                    ...state,
                    allSubDistrictsList: action.payload
                }
        case SET_ALL_VILLAGES_LIST:
                return {
                    ...state,
                    allVillagesList: action.payload
                }
        case SET_ALL_EXAM_MODES_LIST:
            return {
                ...state,
                allExamModesList: action.payload
            }
        case SET_ALL_COORDINATOR_ROLES_LIST:
            return {
                ...state,
                allCoordinatorRoles: action.payload
            } 
        case SET_ALL_COORDINATOR_GENDERS_LIST:
            return {
                ...state,
                allCoordinatorGenders: action.payload
            }    
        case SET_ALL_UNAPPROVAL_ENTITY_LIST:
            return {
                ...state,
                allUnapprovalEntityList:action.payload
            } 
        case SET_ALL_APPROVED_ENTITY_LIST:
            return {
                ...state, 
                allApprovedEntityList:action.payload
            } 
        case SET_UNAPPROVAL_PAGE_NO_COUNTER:
            return {
                ...state,
                unapprovalPageNoCounter:action.payload
            } 
        case SET_APPROVED_PAGE_NO_COUNTER:
            return {
                ...state, 
                approvalPageNoCounter:action.payload
            }    
        case SET_UPLOAD_CSV:
                return{
                    ...state,
                    uploadCsv : action.payload
                }   
        case GET_VENUE_ERRORLIST:
            return{
                ...state,
                venueErrorList:action.payload
            } 
        case SET_ALL_EXAM_CENTERS_LIST_BY_ADVT_ID:
            return {
                ...state,
                allExamCentersListByAdvtId: action.payload
            }   
        case SET_ALL_VENUES_LIST_BY_EXAM_CENTER_ID:
            return {
                ...state,
                allVenuesListByExamCenterId: action.payload
            }
        case SET_VENUE_DETAILS_BY_VENUE_ID:
            return {
                ...state,
                allVenueDetailsList: action.payload
            }
        case SET_ALL_ACTIVE_VENUE_ADVT:
            return {
                ...state,
                allActiveVenueAdvtList: action.payload
            }
        case SET_ALL_ACTIVE_VENUE_ADVT_PAGE_NO_COUNTER:
            return {
                ...state,
                allActiveVenueAdvtPageNoCounter: action.payload
            }  
        case SET_EXAM_DISPLAY_NAME_BY_EXAM_ID:
            return {
                ...state,
                getExamDisplayNameList: action.payload
            }  
        case SET_EXAM_SUBJECTS_LIST:
            return {
                ...state,
                getExamSubjectsDropDownList: action.payload
            }   
        case SET_FORM_2_DATA_STATUS:
            return {
                ...state,
                getForm2DataAlreadyExistsStatus: action.payload
            }               
        default :
            return state;
    }

}